interface Props {
  src?: string
  link?: string
  alt?: string
}
export function Brand({ src, link, alt }: Props) {
  const brand = src ? <img src={src} alt={alt} data-testid="faq-logo" /> : alt

  return (
    <>
      {link ? (
        <a href={link} data-testid="faq-logo-link">
          {brand}
        </a>
      ) : (
        brand
      )}
    </>
  )
}
